import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  useTheme,
  Alert,
} from "@mui/material";
import Swal from "sweetalert2";
import { DataGrid } from "@mui/x-data-grid";
import { CircularProgress } from "@mui/material";
import {
  customerservice,
  loanManagementUrl,
  setupManagementUrl,
} from "../../../config";
import {
  executeAnyMutation,
  fetchJsonDynamic,
  fetchJson,
} from "../../../data/DynamicServiceNew/jsondynamicservice";
import { graphqlQuery } from "../../../data/Axios/DynamicService";
import CustomTable from "../../../data/customtable";
import { tokens } from "../../../theme";
import { Navigate, useNavigate } from "react-router-dom";

const RescheduleLoan = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  // const customersData = [
  //   { id: '36991073', name: 'Lilian Kilani', email: 'fulusi@gmail.com', phone: '0798706353', branch: 'Kitengela', loanLimit: 3000, createdAt: 'Nov 29, 2021' },
  //   // Add more customer data as needed
  // ];
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCustomer, setFilteredCustomer] = useState(null);
  const [amount, setAmount] = useState("");
  const [loanProductSelected, setLoanProductSelected] = useState([]);
  const [customers, setCustomers] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loanscheduledata, setLoanscheduledata] = useState([]);
  const [loanProduct, setLoanProduct] = useState([]);
  const [disbursementData, setDisbursementData] = useState([]);
  const [installmentError, setInstallmentError] = useState("");
  const [noOfInstallments, setNoOfInstallments] = useState(0);

  const resetForm = () => {
    setSearchTerm("");
    setFilteredCustomer(null);
    setAmount("");
    setLoanProductSelected("");
    setNoOfInstallments("");
    setInstallmentError("");
  };

  useEffect(() => {
    const fetchData = async () => {
      const params = { companyId: companyId };
      const productResponse = await fetchJsonDynamic(
        "allProductsByColumnValues",
        "parameters",
        params,
        setupManagementUrl.uri
      );
      const allProducts = JSON.parse(productResponse.results) || [];
      // Filter regions based on selected company ID

      setLoanProduct(allProducts);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (searchTerm.trim() !== "") {
      handlesearch(searchTerm);
    } else {
      setFilteredCustomer(null); // Clear customer data if searchTerm is empty
    }
  }, [searchTerm]);
  
  const selectedLoanProduct = loanProduct.find(
  (p) => p.Id === loanProductSelected
);


  const navigate = useNavigate();

  const handlesearch = async () => {
    setLoadingSearch(true); // Start loading

    try {
      const params = { loanId: parseInt(searchTerm) };

      // Perform API call to search customer
      const customer = await fetchJsonDynamic(
        "allLoanScheduleByLoanId",
        "parameters",
        params,
        loanManagementUrl.uri,
      );

      const result = JSON.parse(customer.results);

      if (result === null || result.length === 0) {
        Swal.fire("Sorry!", `${customer.error}`, "warning");
      } else {
        setFilteredCustomer(result.LoanApplications || null); // Update state with customer data
        setLoanscheduledata(result.LoanSchedules || []);
        setDisbursementData(result.disbursements || []);
      }
    } catch (error) {
      console.error("Search error:", error);
      Swal.fire(
        "Search Failed",
        "An error occurred during the search. Please try again later.",
        "error"
      );
    } finally {
      setLoadingSearch(false); // End loading after search is completed
    }
  }; // Short debounce delay for a smoother typing experience

  const handlesababisha = () => {
    navigate("/sababisha");
  };

  const extractMessageText = (errorString) => {
    const match = errorString.match(/MessageText:\s*([^\\]+?)(\\r|\\n|$)/);
    return match ? match[1].trim() : "MessageText not found";
  };
  // Extract only the "Error" part
  const extractError = (errorString) => {
    const match = errorString.match(/Error: (.+?)\\n/);
    return match ? match[1] : "Error not found";
  };

  const handleAppraisalSubmit = async () => {
      // Validate installments if dynamic installment is enabled
    if (selectedLoanProduct.IsdynamicInstallment === 1) {
      const min = selectedLoanProduct.MinimumTerm || 0;
      const max = selectedLoanProduct.MaximumTerm || Infinity;
      const numInstallments = parseInt(noOfInstallments, 10);

      if (!noOfInstallments || isNaN(numInstallments)) {
        setInstallmentError("Please enter a valid number of installments");
        return;
      }

      if (numInstallments < min || numInstallments > max) {
        setInstallmentError(`Installments must be between ${min} and ${max}`);
        return;
      }
    }

    setLoadingSubmit(true); // Start loading when the form is submitted

    try {
      const mutationData = {
        p_loanid: filteredCustomer[0].Id,
        p_productid: loanProductSelected,
        p_installment: parseInt(noOfInstallments, 10) || null,
      };

      const response = await executeAnyMutation(
        "rescheduleLoan",
        mutationData,
        "loanReschedule",
        false,
        loanManagementUrl.uri
      );
      if (response.results !== null) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Loan Rescheduled Successfully!",
        });
        // Reset form upon successful submission
        handlesearch();
      } else {
        const messageText = extractMessageText(response.error);
        Swal.fire({
          icon: "error",
          title: "Sorry!",
          text: `${messageText}`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
      resetForm();
    } finally {
      setLoadingSubmit(false); // End loading after the process
    }
  };
    // Function to get the current product name
    const getCurrentProductName = () => {
      if (!filteredCustomer || !filteredCustomer[0] || !loanProduct.length) return "N/A";
      
      const productId = filteredCustomer[0].ProductId;
      const product = loanProduct.find((p) => p.Id === productId);
      return product ? product.Name : " ";
    };
  

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h5">Re-Schedule Loan</Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <TextField
            label="Search Loan by Loan ID"
            placeholder="Enter search criteria"
            variant="outlined"
            fullWidth
            margin="normal"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              endAdornment: loadingSearch && (
                <CircularProgress size={24} sx={{ marginRight: 2 }} />
              ),
            }}
          />
        </Grid>
      </Grid>

      {filteredCustomer && (
        <>
          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent sx={{ bgcolor: `${colors.primary[400]} !important` }}>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: `${colors.blueAccent[700]} !important`,
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Loan Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Loan Id:</strong> {filteredCustomer[0].Id}
                  </Typography>
                  <Typography>
                    <strong>Amount To disburse:</strong>{" "}
                    {filteredCustomer[0].AmountToDisburse}
                  </Typography>
                  <Typography>
                    <strong>Customer Phone:</strong>{" "}
                    {filteredCustomer[0].CustomerPhone}
                  </Typography>
                  <Typography>
                    <strong>Loan Status:</strong>{" "}
                    <span
                      style={{
                        color: disbursementData.length > 0 && disbursementData[0]?.IsSent
                        ? colors.greenAccent[400]
                          : colors.redAccent[400],
                      }}
                    >
                         {disbursementData.length > 0 && disbursementData[0]?.IsSent
                          ? "Sent" : "Not Sent"}
                    </span>
                  </Typography>
                  <Typography>
                    <strong>Current Product:</strong>{" "}
                    {getCurrentProductName()}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Application Date:</strong>{" "}
                    {filteredCustomer[0].ApplicationDate
                      ? new Date(
                          filteredCustomer[0].ApplicationDate
                        ).toLocaleDateString("en-Us", {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        })
                      : " "}
                  </Typography>
                  <Typography>
                    <strong>Company Comments:</strong>{" "}
                    {filteredCustomer[0].CompanyComments}
                  </Typography>
                 
                  <Typography>
                    <strong>Date Created:</strong>{" "}
                    {filteredCustomer[0].DateCreated
                      ? new Date(
                          filteredCustomer[0].DateCreated
                        ).toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        })
                      : " "}
                  </Typography>
                  <Typography>
                    <strong>Expected Clear Date:</strong>{" "}
                    {filteredCustomer[0].ExpectedClearDate
                      ? new Date(
                          filteredCustomer[0].ExpectedClearDate
                        ).toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        })
                      : " "}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

              <Card variant="outlined" sx={{ mb: 2 }}>
                <CardContent
                  sx={{ bgcolor: `${colors.primary[400]} !important` }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      backgroundColor: `${colors.blueAccent[700]} !important`,
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: 1,
                      ml: 3,
                      mr: 2,
                    }}
                  >
                    Loan Schedules
                  </Typography>
                </CardContent>
                <CardContent
                  sx={{ bgcolor: `${colors.primary[400]} !important` }}
                >
                  <CustomTable data={loanscheduledata} />
                </CardContent>
              </Card>
                {/* Checking if the loan is disbursed */}
          
            <>
              <Card variant="outlined" sx={{ mb: 2 }}>
                <CardContent
                  sx={{ bgcolor: `${colors.primary[400]} !important` }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      backgroundColor: `${colors.blueAccent[700]} !important`,
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: 1,
                      ml: 3,
                      mr: 2,
                    }}
                  >
                    Reschedule Loan
                  </Typography>
                  <Grid container spacing={2} alignItems="center">
                    {/* Select (Loan Product) */}
                    <Grid item xs={12} sm={8}>
                      <FormControl fullWidth>
                        <InputLabel sx={{ mt: 3, ml: 3 }}>
                          Loan Product
                        </InputLabel>
                        <Select
                          value={loanProductSelected}
                          onChange={(e) =>
                            setLoanProductSelected(e.target.value)
                          }
                          defaultValue=""
                          sx={{ mt: 3, ml: 3 }}
                        >
                          <MenuItem value="" disabled>
                            Select Loan Product
                          </MenuItem>
                          {loanProduct.map((company) => (
                            <MenuItem key={company.Id} value={company.Id}>
                              {company.Name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    {/* Dynamic Installments section */}
                      {/* Show No of Installments only if IsDynamicInstallment === 1 */}
                                  {selectedLoanProduct?.IsdynamicInstallment === 1 && (
                                     <Grid container spacing={2} sx={{ mt: 1 ,ml: 3 }}>
                                     <Grid item xs={12} sm={4}>
                                       <TextField
                                         fullWidth
                                         variant="outlined"
                                         label="Minimum Installment"
                                         value={selectedLoanProduct?.MinimumTerm || ""}
                                         disabled
                                       />
                                     </Grid>
                                     <Grid item xs={12} sm={4}>
                                       <TextField
                                         fullWidth
                                         variant="outlined"
                                         label="Maximum Installment"
                                         value={selectedLoanProduct?.MaximumTerm || ""}
                                         disabled
                                       />
                                     </Grid>
                                      <Grid item xs={12} sm={6}>
                                        <TextField
                                          fullWidth
                                          variant="outlined"
                                          label="No of Installments"
                                          placeholder="Enter Number of Installments"
                                          value={noOfInstallments}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            // Only check if it's a valid number (not empty or numeric)
                                            if (value === "" || /^\d*$/.test(value)) {
                                              setNoOfInstallments(value);
                                              setInstallmentError(""); // Clear error when user types
                                            }
                                          }}
                                          error={!!installmentError}
                                          helperText={installmentError || `Enter between ${selectedLoanProduct?.MinimumTerm || null} and ${selectedLoanProduct?.MaximumTerm || null}`}
                                        />
                                      </Grid>
                                    </Grid>
                                  )}

                    {/* Button (Reschedule Loan) */}
                    <Grid item xs={12} sm={4}>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ mt: 2, mr: 1 }}
                        onClick={handleAppraisalSubmit}
                        disabled={loadingSubmit}
                      >
                        {loadingSubmit ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          "Reschedule Loan"
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </>
          
        </>
      )}
    </Box>
  );
};

export default RescheduleLoan;
